import { useRouter } from 'next/router';

import Checkmark from 'svgs/summit/checkmark.svg';
import Searching from 'svgs/summit/searching.svg';

import { Badges } from 'components/SummitFlow/Badges';
import { FC, useEffect, useState } from 'react';

import styles from './index.module.scss';

export const HeroSearching: FC = () => {
  const [status, setStatus] = useState(0);
  const [location, setLocation] = useState('');

  const router = useRouter();

  useEffect(() => {
    const fields = JSON.parse(sessionStorage.getItem('fields') || '{}');
    setLocation(fields?.location || 'Your Area');
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setStatus((prevStatus) => {
        if (prevStatus < 4) {
          return prevStatus + 1;
        } else {
          clearInterval(interval);
          router.push('/summit/contact');
          return prevStatus;
        }
      });
    }, 1500);

    return () => clearInterval(interval);
  }, [setStatus, router]);

  return (
    <div className="summit-wrapper">
      <div className={styles['searching-hero-container']}>
        <div className="container">
          <h1>Sit Back While We Find Roofing Prices in {location}</h1>
          <h2>Easily Contact your Local Roofer</h2>
          <div className={styles['loader-container']}>
            <div className={styles['spinner-container']}>
              <Searching />
            </div>
            <ul className={styles['status']}>
              <li className={`${status >= 1 ? styles['done'] : ''}`}>
                <Checkmark /> Location
              </li>
              <li className={`${status >= 2 ? styles['done'] : ''}`}>
                <Checkmark /> Roofing Providers
              </li>
              <li className={`${status >= 3 ? styles['done'] : ''}`}>
                <Checkmark /> Project Fit
              </li>
              <li className={`${status >= 4 ? styles['done'] : ''}`}>
                <Checkmark /> Price Comparison
              </li>
            </ul>
          </div>
        </div>
        <div className={styles['badges-wrapper']}>
          <Badges />
        </div>
      </div>
    </div>
  );
};
